export const environment = {
  production: true,
  configEnv: 'cloudrun' as const,
};
